<template>
  <div class="promotions">
    <div class="page-head Promotions">
      <!--START - Control panel above projects-->
      <div>
        <div class="os-tabs-controls mx-2">
          <ul class="nav nav-tabs upper mt-2">
            <li class="nav-item">
              <router-link :to="{ query: { type: 1 } }" class="nav-link"
                           exact-active-class="active"
                           exact> {{ t.promotion.modes.sportsboook }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ query: { type: 2 } }" class="nav-link"
                           exact-active-class="active"
                           exact> {{ t.promotion.modes.casino }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <!--END - Control panel above projects-->
    </div>
    <div class="app-container mx-3">
      <div class="row">
        <div class="col-4" v-for="promotion in promotions" :key="promotion.id">
          <a href="javascript:;" @click="openPromotion(promotion.id)" class="promotion-item"
                       exact-active-class="active" exact>
            <promotionItem :promotion="promotion"/>
          </a>
        </div>
      </div>

      <sweet-modal ref="promotionModal" width="800" v-on:close="closePromotion">
        <promotionDetail :pid="selectedPromotion" v-if="selectedPromotion"/>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import promotionItem from '@/components/promotion/item';
import promotionDetail from '@/components/promotion/detail';

export default {
  name: 'promotionList',
  components: {promotionItem, promotionDetail},
  data() {
    return {
      t: this.$root.t,
      promotions: [],
      session: this.$root.session,
      selectedPromotion: 0
    }
  },
  watch: {
    '$root.session'() {
      this.session = this.$root.session
      this.fetchPromotions();
    },
    '$route'() {
      this.fetchPromotions();
      if (this.$route.params.id) {
        this.openPromotion(this.$route.params.id)
      }
    },
  },
  mounted() {
    if (session) {
      setTimeout(this.fetchPromotions, 500);
    }

    if (this.$route.params.id) {
      this.openPromotion(this.$route.params.id)
    }
  },
  methods:
      {
        fetchPromotions() {
          this.$http.get(api + 'api/v1/promotions', {params: {mod: this.$route.query.type}}).then(response => {

            if (response.body.promotions) {
              this.promotions = response.body.promotions;
            }

          }, response => {
            // error callback
          });
        },
        openPromotion(pid) {
          this.selectedPromotion = pid;
          this.$refs.promotionModal.open();

        },
        closePromotion() {
          this.selectedPromotion = null;
          this.$router.push({name: 'Promotions'})

          setTimeout(() => {
            document.body.style.overflow = 'auto';
          }, 500);
        },
      }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.app-container {
  min-width: 1200px;
}

</style>



// WEBPACK FOOTER //
// src/components/promotion/list.vue